import { render, staticRenderFns } from "./formEquipment.vue?vue&type=template&id=10f7c232"
import script from "./formEquipment.vue?vue&type=script&lang=js"
export * from "./formEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f7c232')) {
      api.createRecord('10f7c232', component.options)
    } else {
      api.reload('10f7c232', component.options)
    }
    module.hot.accept("./formEquipment.vue?vue&type=template&id=10f7c232", function () {
      api.rerender('10f7c232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/router/components/form/formEquipment.vue"
export default component.exports